import React from 'react';
import {
  Select,
  SelectContent,
  SelectItem,
} from '@frontend/shadcn/components/ui/select';
import { SelectBase } from './SelectBase';

interface SingleSelectProps {
  options: string[];
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  placeholder?: string;
}

export const SingleSelect: React.FC<SingleSelectProps> = ({
  options,
  value = '',
  onChange,
  disabled = false,
  placeholder = ''
}) => {
  return (
    <Select
      value={value}
      onValueChange={onChange}
      disabled={disabled}
    >
      <SelectBase
        value={value}
        placeholder={placeholder}
        isMulti={false}
        hasValue={!!value}
      />
      <SelectContent>
        {options.map((option) => (
          <SelectItem
            key={option}
            value={option}
            className={value === option ? 'bg-gray-100' : ''}
          >
            {option}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
